import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps"
import { useTranslation } from "react-i18next";
const CurrencyAutoComplete: React.FC<AutoCompleteProps> = ({
    onChange,
    valueId,
    label ,
    load = true,
    disabled = false,
    infoText,
    error,
    helperText,
    selectFirst
}) => {
    const { t } = useTranslation();
    return (

        <AsyncAutoCompleteContained
            label={label ?? t("common.currency")}
            url="/autocompleteApi/Currencies"
            valueId={valueId}
            load={load}
            onChange={onChange}
            disabled={disabled}
            infoText={infoText}
            error={error}
            helperText={helperText}
            selectFirst={selectFirst}
        />
    );
};

export default CurrencyAutoComplete;
